import { render } from "./FormularioAulaReposicao.vue?vue&type=template&id=b198aebe&scoped=true"
import script from "./FormularioAulaReposicao.vue?vue&type=script&lang=js"
export * from "./FormularioAulaReposicao.vue?vue&type=script&lang=js"

import "./FormularioAulaReposicao.vue?vue&type=style&index=0&id=b198aebe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b198aebe"]])

export default __exports__